import React from "react";

const Baloon = props => (
  <svg viewBox="0 0 17 14" fill="none" {...props}>
    <path
      d="M9 1c3.844 0 7 2.469 7 5.5S12.844 12 9 12a9.191 9.191 0 01-2.625-.375l-.469-.156-.406.281c-.719.5-1.813 1.094-3.188 1.25a8.61 8.61 0 001.25-2.188l.22-.593-.407-.438C2.469 8.812 2 7.687 2 6.5 2 3.469 5.125 1 9 1zm0-1C4.562 0 1 2.938 1 6.5c0 1.5.594 2.875 1.625 3.969-.438 1.219-1.406 2.281-1.438 2.281-.218.219-.25.531-.156.813A.75.75 0 001.72 14c1.937 0 3.437-.781 4.375-1.438A9.753 9.753 0 009 13c4.406 0 8-2.906 8-6.5C17 2.937 13.406 0 9 0z"
      fill="currentColor"
    />
  </svg>
);

export default Baloon;
